<template>
	<div :id="id">
		<!-- small box -->
		<div class="small-box" :class="`bg-${theme}`">
			<div class="small-box-footer">
				<slot name="search">
					<div class="nav navbar navbar-expand p-0" style="width: 100%;">
						<a class="btn btn-sidebar ml-1 mr-1 float-right" :class="`bg-${theme}`" href="#"><i class="fas fa-search"></i></a>
					</div>
				</slot>
			</div>
			<div class="inner">
				<h3>
					<d2-count-up ref="vchart" :end="count" :decimals="decimals" />
				</h3>
				<p>{{ title }}</p>
			</div>
			<div class="icon">
				<i :class="icon" style="margin-top: 40px;"></i>
			</div>
			<div class="small-box-footer">
				<slot name="card-tools" v-bind:theme="theme"></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'lyai-count',
		props: {
			theme: {
				type: String,
				default () {
					return 'gradient-primary'
				}
			},
			icon: {
				type: String,
				default () {
					return 'fas fa-clock'
				}
			},
			id: {
				type: String,
				default () {
					return 'id'
				}
			},
			data: {
				type: Object
			},
			title: {
				type: String,
				default () {
					return '折线图'
				}
			},
			checked: {
				type: Boolean,
				default () {
					return false
				}
			},
			time: {
				type: Number,
				default () {
					return 5
				}
			},
			auto: {
				type: Boolean,
				default () {
					return false
				}
			},
			settings: {
				type: Object
			},
		},
		data() {
			return {
				body: undefined,
				loading: undefined,
				interval: undefined
			}
		},
		created() {
			this.updateData()
		},
		computed: {
			count() {
				if (this.data.rows === undefined) {
					return 0
				}
				const row = this.data.rows[0]
				if (row === undefined) {
					return 0
				}
				if (this.data.columns.length < 1) {
					return 0
				}
				if (this.data.columns.length === 1) {
					const [key] = this.data.columns
					return row[key]
				}
				const [, key] = this.data.columns
				return row[key]
			},
			decimals() {
				const decimals = this.settings.decimals
				if (decimals) {
					return decimals
				}
				return 0
			},
		},
		watch: {
			checked(val) {
				if (val) {
					this.updateData()
				}
			},
			auto(val) {
				if (val) {
					this.interval = setInterval(() => {
						this.updateData(true)
					}, this.time * 1000)
				} else {
					clearInterval(this.interval)
				}
			},
			time(val) {
				if (this.auto) {
					clearInterval(this.interval)
					this.interval = setInterval(() => {
						this.updateData(true)
					}, val * 1000)
				}
			}
		},
		methods: {
			updateData() {
				if (this.auto) {
					this.$emit('updateData', () => {
						this.$nextTick(() => {
							this.loading = this.$loading({
								target: document.getElementById(this.id),
								text: 'Loading',
								spinner: 'el-icon-loading',
								background: 'rgba(0, 0, 0, 0.7)'
							})
						})
					}, () => {
						this.$nextTick(() => {
							setTimeout(() => {
								this.loading && this.loading.close()
							}, 500)
						})
					})
					return
				}
				this.$emit('updateData', () => {
					this.$nextTick(() => {
						this.loading = this.$loading({
							target: document.getElementById(this.id),
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						})
					})
				}, () => {
					this.$nextTick(() => {
						setTimeout(() => {
							this.loading && this.loading.close()
						}, 500)
					})
				})
			}
		}
	}
</script>
<style scoped="scoped" type="text/css">
	.scrollbar::-webkit-scrollbar {
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}
	
	.scrollbar::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #7f7f7f;
	}

	.scrollbar::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}
</style>
